import axios from '@/axios';

const RESOURCE_NAME = '/admin/ai-prompts';

export default {
    getList(data) {
        return axios.post(`${RESOURCE_NAME}/get-list`, data)
    },

    getIndexList(data) {
        return axios.post(`${RESOURCE_NAME}/get-index-list`, data)
    },

    getEdit(id) {
        return axios.get(`${RESOURCE_NAME}/get-edit?id=${id}`)
    },

    save(id, data) {
        return axios.post(`${RESOURCE_NAME}/save?id=${id}`, data)
    },

    run(data) {
        return axios.post(`${RESOURCE_NAME}/run`, data)
    },

    getVersionText(id) {
        return axios.get(`${RESOURCE_NAME}/get-version-text?version_id=${id}`)
    },
}
